import type { DataAvailabilityResponse } from 'ag-common-lib/lib/contracts/reporting-api.contracts';
import { dateOnly, isPaidReport } from './report-period.utils';

export interface ReportDataAvailability extends DataAvailabilityResponse {
  /** Optional lower bounds enable historical periods without guessing dataset coverage. */
  paidDataAvailableFrom?: string | null;
  submittedDataAvailableFrom?: string | null;
}
export function availabilityForReport(
  data: ReportDataAvailability,
  reportId: string,
): { through: string | null; from: string | null } {
  return isPaidReport(reportId)
    ? { through: data.paidDataAvailableThrough, from: data.paidDataAvailableFrom ?? null }
    : { through: data.submittedDataAvailableThrough, from: data.submittedDataAvailableFrom ?? null };
}
export function normalizeReportDataAvailability(response: unknown): ReportDataAvailability {
  const payload = response && typeof response === 'object' && 'data' in response ? response.data : response;
  const data = payload && typeof payload === 'object' ? (payload as Partial<ReportDataAvailability>) : null;
  return {
    paidDataAvailableThrough: dateOnly(data?.paidDataAvailableThrough),
    submittedDataAvailableThrough: dateOnly(data?.submittedDataAvailableThrough),
    paidDataAvailableFrom: dateOnly(data?.paidDataAvailableFrom),
    submittedDataAvailableFrom: dateOnly(data?.submittedDataAvailableFrom),
  };
}
export function sessionDataAvailability(data: ReportDataAvailability): { through: string | null; from: string | null } {
  const paid = data.paidDataAvailableThrough;
  const submitted = data.submittedDataAvailableThrough;
  const from =
    data.paidDataAvailableFrom && data.submittedDataAvailableFrom
      ? data.paidDataAvailableFrom > data.submittedDataAvailableFrom
        ? data.paidDataAvailableFrom
        : data.submittedDataAvailableFrom
      : null;
  return { through: paid && submitted ? (paid < submitted ? paid : submitted) : null, from };
}
